'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const SelectItemC = styled__default["default"].button.withConfig({
  componentId: "sc-eu89yq-0"
})(["box-sizing:border-box;border:0 none;padding:16px;cursor:pointer;border-radius:4px;background-color:inherit;font-family:inherit;font-weight:inherit;color:inherit;text-align:left;", " @media (hover:hover){&:hover{", ";", ";}}", " ", " ", " ", ""], _ref => {
  let {
    sDefault
  } = _ref;
  return sDefault;
}, _ref2 => {
  let {
    selected,
    readOnly,
    borderless,
    sActive
  } = _ref2;
  return !selected && !readOnly && !borderless && styled.css({
    borderWidth: '1px',
    borderStyle: 'solid',
    ...style.getBordersColor(sActive, '#000000')
  });
}, _ref3 => {
  let {
    selected,
    readOnly,
    transparent,
    sDefault
  } = _ref3;
  return !selected && !readOnly && !transparent && styled.css({
    backgroundColor: (sDefault === null || sDefault === void 0 ? void 0 : sDefault.backgroundColor) ?? 'rgba(0, 0, 0, 0.05)',
    filter: sDefault !== null && sDefault !== void 0 && sDefault.backgroundColor ? 'brightness(95%)' : undefined
  });
}, _ref4 => {
  let {
    selected,
    borderless,
    transparent,
    sDefault,
    sActive
  } = _ref4;
  const activeCss = {
    ...(!borderless ? {
      borderWidth: 2,
      borderStyle: 'solid',
      ...style.getBordersColor(sActive, '#000000')
    } : {}),
    backgroundColor: !transparent ? (sActive === null || sActive === void 0 ? void 0 : sActive.backgroundColor) ?? (sDefault === null || sDefault === void 0 ? void 0 : sDefault.backgroundColor) : undefined
  };
  return selected ? activeCss : {};
}, _ref5 => {
  let {
    readOnly
  } = _ref5;
  return readOnly && 'cursor: inherit;';
}, _ref6 => {
  let {
    borderless
  } = _ref6;
  return borderless && 'border: none;';
}, _ref7 => {
  let {
    transparent
  } = _ref7;
  return transparent && 'background: inherit;';
});
const SelectItem = _ref8 => {
  let {
    onClick,
    ...props
  } = _ref8;
  const {
    documentbodyNoneNone,
    bodytextDefaultNone,
    panelcontainerNoneNone,
    selecteditemNoneNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(SelectItemC, _extends__default["default"]({
    sDefault: {
      ...bodytextDefaultNone,
      ...panelcontainerNoneNone,
      backgroundColor: (documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor) ?? (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.backgroundColor)
    },
    sActive: selecteditemNoneNone,
    onClick: props.readOnly ? undefined : onClick,
    as: props.readOnly ? 'div' : undefined
  }, props));
};
var SelectItem$1 = nthHookTheme.withThemeProvider(SelectItem, {
  themeTokens: ['documentbodyNoneNone', 'bodytextDefaultNone', 'panelcontainerNoneNone', 'selecteditemNoneNone']
});

exports["default"] = SelectItem$1;
